/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { $api } from "@/services/ApiService";
import { $auth } from "@/services/AuthenticationService";
import { myRoutes } from "./my";
import { adminRoutes } from "./admin";

import Welcome from "@/views/Welcome.vue";
import Gateway from "@/views/Gateway.vue";
import Layout from "@/views/Layout.vue";
import { config } from "../config";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Welcome",
    component: Welcome,
    meta: {
      public: true,
    },
  },
  {
    path: "/gateway",
    name: "Gateway",
    component: Gateway,
    // Sets currentUser if not set and checks for user roles
    // before redirecting to corresponding views.
    beforeEnter: async (to, from, next) => {
      if ($auth.currentUser == null) {
        try {
          const user = await $api.client.user.profile.get().toPromise();
          $auth.currentUser = user;
        } catch {
          // if err fetching user logout
          $auth.logout({
            post_logout_redirect_uri: window.location.origin + config.path + "/?notify=error",
          });
          return next(false);
        }
      }
      if (to.query && typeof to.query.redirect_to === "string") {
        if (to.query.redirect_to.includes("/admin") && !$auth.hasAnyAdmin()) {
          next("/my");
        } else {
          next(to.query.redirect_to);
        }
      } else {
        if (!$auth.hasAnyAdmin()) {
          next("/my");
        } else {
          next();
        }
      }
    },
  },
  {
    path: "/my",
    children: myRoutes,
    component: Layout,
    meta: {
      prefix: "/my",
    },
  },
  {
    path: "/admin",
    children: adminRoutes,
    component: Layout,
    meta: {
      prefix: "/admin",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.public) {
    const user = await $auth.getIdentity();
    if (user == null) {
      next("/");
    } else {
      $auth.accessToken = user.access_token;
      if ($auth.currentUser == null && to.path != "/gateway") {
        next({ path: "/gateway", query: { redirect_to: to.path } });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
